import React from 'react'
import PropTypes from 'prop-types'
import ToolTipV2 from 'Components/ToolTipV2'

import {
  _CalcOutputBox,
  _Label,
  _Result,
  _Suffix,
} from './styles'

const CalcOutputBox = ({ label, output, highlighted, enableTooltip, tooltipInfo, bold, suffix }) => (
  <_CalcOutputBox>
    <_Label bold={bold}>{label} {enableTooltip && (<ToolTipV2 {...tooltipInfo} />)}</_Label>
    <_Result highlighted={highlighted}>
      ${ output }
    </_Result>
    {
      suffix && (
        <_Suffix>
          {suffix}
        </_Suffix>
      )
    }
  </_CalcOutputBox>
)


CalcOutputBox.propTypes = {
  label: PropTypes.string.isRequired,
  output: PropTypes.string.isRequired,
  highlighted: PropTypes.string,
  enableTooltip: PropTypes.bool,
  suffix: PropTypes.string,
  bold: PropTypes.bool,
  tooltipInfo: PropTypes.shape({}),
}


export default CalcOutputBox
